import React, { useState, useMemo, useContext, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Flow as FlowComponent, useDrawer, Confirm, DrawerButton, DownloadButton } from 'src/mtska-frontend-app-component';
import { useGridApiRef } from '@mui/x-data-grid';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import JSONPretty from 'react-json-pretty'
import '@xyflow/react/dist/style.css';

import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { useLoadAll } from 'src/mtska-frontend-data-provider/hooks/useLoadAll.hooks';

const dataProviderName = 'administrations/revenuedeal';
const drawerRouteBase = 'revenuedeals';

const moduleName = "Revenue Deals";
const wizardAction = 'destroy';

const Flow = (params) => {
    const { t } = useTranslation();
    const { userCapabilities } = useContext(AppContext);
    const { activate } = useDrawer();

    const apiRef = useGridApiRef();
    const getSelected = () => {
        return [...apiRef.current.getSelectedRows()].map(([name]) => name);
    };
    const [selected, setSelected] = useState([]);
    const handleRowSelection = (newSelection) => {
        setSelected(newSelection);
        params.rowSelectionExternalListener && params.rowSelectionExternalListener(newSelection);
    };

    const getFunctionalButtons = useMemo(() => {
        let rb = [];

        if (userCapabilities && userCapabilities[dataProviderName + '.delete'] && selected.length) {
            rb.push(
                <Button
                    disabled={userCapabilities && !userCapabilities[dataProviderName + '.delete']}
                    onClick={() => { handleDelete(); }}
                    label={t("Delete") + " (" + selected.length + ")"}
                    icon={"faTrash"}
                    variant="outlined"
                    size="small"
                    className="button-delete"
                />
            );
        }

        return rb;
    }, [selected, userCapabilities]);


    const [confirmDelete, setConfirmDelete] = useState();
    const handleDelete = () => {
        setConfirmDelete(
            <Confirm
                oklabel={t("Delete")}
                okcallable={async () => {
                    doAction && await doAction({ action: wizardAction, model: dataProviderName, data: getSelected() });
                    setConfirmDelete(null);
                    apiRef.current.setRowSelectionModel([]);
                    loadAll();
                }}
                kolabel={t("Cancel")}
                kocallable={() => { setConfirmDelete(null) }}
                title={t("Items elimination")}>
                {t("Are you sure to remove the selected elements?")}
            </Confirm>
        );
    }

    const { doAction, loadAll, items, total, loading, download, downloading, reloadCounter } = useDataProvider(dataProviderName);
    const [listFilterPageSort, setListFilterPageSort] = useState();
    const handleFilterPageSortChange = (model) => {
        setListFilterPageSort(model);
    }

    useLoadAll({ listFilterPageSort, loadAll, params, reloadCounter })

    const handleNodeDoubleclick = (node, event) => {
        if (event.target.classList.contains('connectable')) {
            activate(drawerRouteBase + '/create', { parentRevenueDeal: node.data.item });
        } else {
            activate(drawerRouteBase + '/detail', { id: node.data.item.id });
        }
    }

    const onConnectStart = (node) => {
        activate(drawerRouteBase + '/create', { parentRevenueDeal: node.data.item });
    }

    return (
        <>
            {userCapabilities && userCapabilities[dataProviderName + '.list'] && (
                <FlowComponent
                    {...params}
                    items={items}
                    nodeElementType={'deal'}
                    childrenNodeKey={'childrenRevenueDeals'}
                    onConnectStart={onConnectStart}
                    onNodeDoubleClick={(userCapabilities && userCapabilities[dataProviderName + '.view']) ? handleNodeDoubleclick : () => { }}
                    onFilterPageSortChange={handleFilterPageSortChange}
                    //rowSelectionExternalListener={handleRowSelection}
                    dataProviderName={dataProviderName}
                    loading={loading}
                />
            )}
            {confirmDelete}
        </>
    );
};

export default Flow;


